const AbstractCloverRequestRecord = require('./AbstractCloverRequestRecord');
const CloverReceiptDeliveryMethod = require('@/lib/PaymentMethods/Clover/Enums/CloverReceiptDeliveryMethod');

class CloverReceiptVoidRequestRecord extends AbstractCloverRequestRecord {
    /**
     * @param {string} voidId // A uuid.
     * @param {} deliveryOption
     */
    constructor(voidId, deliveryOption) {
        if (!voidId || voidId.trim() === '') {
            throw new Error('voidId is required');
        }
        if (
            // @Todo test against actual DeliveryOption object.
            !deliveryOption
            || !deliveryOption.method
            || !CloverReceiptDeliveryMethod.hasOwnProperty(deliveryOption.method)
        ) {
            const methods = Object.values(CloverReceiptDeliveryMethod).join(', ');
            throw new Error('deliveryOption is required and must be one of ' + methods);
        }
        // @link https://docs.clover.com/reference/receipt_options
        const url = '/connect/v1/payments/' + voidId + '/void/receipt';
        super(
            'POST',
            url
        );
        this.data = {
            // printJobId,
            deliveryOption,
        };
    }
}

module.exports = CloverReceiptVoidRequestRecord;
